module.exports = __webpack_public_path__ + "img/yzm2.96a94510.png";